export default __webpack_public_path__ + "locales/az/ConvertPasswordDialog.json?hash=bf35d0c83dc523dd93683a9307d2096b";